// extracted by mini-css-extract-plugin
export var columns = "Section-module--columns--3vZyq";
export var content = "Section-module--content--l2D9L";
export var root = "Section-module--root--VS2eI";
export var short = "Section-module--short--ivSmq";
export var title = "Section-module--title--WeD6D";